import select from '@signal/utils/select';
import { createThemeSelector, createVariableThemeSelectorCreator } from './utils';
export var zIndexSelector = createThemeSelector(function (theme) {
  return theme.zIndex;
});
export var getElevationLayerSelector = createVariableThemeSelectorCreator(function (layerName) {
  return createThemeSelector(zIndexSelector, select(layerName));
});
export var appBarZIndexSelector = getElevationLayerSelector('appBar');